import { render, staticRenderFns } from "./shortAnswer.vue?vue&type=template&id=a6909e14&scoped=true&"
import script from "./shortAnswer.vue?vue&type=script&lang=js&"
export * from "./shortAnswer.vue?vue&type=script&lang=js&"
import style0 from "./shortAnswer.vue?vue&type=style&index=0&id=a6909e14&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6909e14",
  null
  
)

export default component.exports